import { FieldErrorText, FieldsetErrorText } from '@chakra-ui/react';
import { msg } from '@lingui/core/macro';
import { Trans } from '@lingui/react';

type ErrorMessageProps = {
  error?: React.ReactNode;
  isFieldset?: boolean;
};

const errorMessages = {
  required: msg`required`,
  'game.required': msg`game.required`,
  'game.alreadyExists': msg`game.alreadyExists`,
  'postText.min': msg`postText.min`,
  'postText.max': msg`postText.max`,
  'comment.max': msg`comment.max`,
  'about.max': msg`about.max`,
  'birthday.minAge': msg`dashboard:settings.profile.dateOfBirthRestrictions`,
  'displayName.symbols': msg`displayName.symbols`,
  'displayName.format': msg`displayName.format`,
  'displayName.min': msg`displayName.min`,
  'displayName.max': msg`displayName.max`,
  'email.wrongFormat': msg`email.wrongFormat`,
  'password.min': msg`password.min`,
  'password.max': msg`password.max`,
  'password.minSymbols': msg`password.minSymbols`,
  'password.match': msg`password.match`,
};

export const ErrorMessage = ({ error, isFieldset }: ErrorMessageProps) => {
  const ErrorText = isFieldset ? FieldsetErrorText : FieldErrorText;

  if (error) {
    return (
      <ErrorText textStyle="body" color="fg.error">
        {typeof error === 'string' && Reflect.has(errorMessages, error) ? (
          <Trans id={errorMessages[error as keyof typeof errorMessages]?.id} />
        ) : (
          error
        )}
      </ErrorText>
    );
  }

  return null;
};
